import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './StoreInfo.scss'

class StoreInfo extends PureComponent {
  render () {
    return (
      <div className='store-info' itemProp='address' itemScope itemType='http://schema.org/PostalAddress'>
        {
          <p className='si-detail si-detail-address' tabIndex='0'>
            <span className='argos-icon icon-UIE-Location' aria-hidden='true' />
            {
              this.props.address &&
              <span itemProp='streetAddress'>{this.props.address}</span>
            }
            {
              this.props.town &&
              <span hidden className='data-test' itemProp='addressLocality'>{this.props.town}</span>
            }
            {
              this.props.postcode &&
              <span>, <span itemProp='postalCode'>{this.props.postcode}</span></span>
            }
          </p>
        }
        {
          this.props.tel && this.props.tel !== '111111' &&
          <a href={'tel:' + this.props.tel.replace(/ /g, '')} className='si-detail si-detail-tel'>
            <span className='argos-icon icon-UIE-Telephone' aria-hidden='true' />
            <span className='sr-only'>Telephone number: </span>
            <span itemProp='telephone'>{this.props.tel}</span>
          </a>
        }
        <p className='si-detail si-detail-storenumber' tabIndex='0'>
          <span className='argos-icon icon-UIE-ApplyInStore' aria-hidden='true' />
          Store Number: {this.props.storeid}
        </p>
      </div>
    )
  }
}

StoreInfo.propTypes = {
  address: PropTypes.string,
  town: PropTypes.string,
  postcode: PropTypes.string,
  tel: PropTypes.string,
  storeid: PropTypes.string.isRequired
}

export default StoreInfo



// WEBPACK FOOTER //
// ./src/components/Details/StoreInfo/StoreInfo.jsx